import posthog from "posthog-js";

export const init = (): void => {
  posthog.init("phc_pAmodD3CFAfeknbuW2lvcEKoLJeKy6T5lk04tSWa99I", {
    api_host: "https://eu.i.posthog.com",
    person_profiles: "identified_only",
  });
};
